//
//This module is used to store token, user id into local storage
//

function storeToken(token) {
    localStorage.setItem("token", token);
}

function storeRestaurantOwnerId(id) {
    localStorage.setItem("restaurantOwnerId", id);
}

function storeRestaurantOwnerName(name) {
    localStorage.setItem("restaurantOwnerName", name);
}

function storePhoneNumber(phone) {
    localStorage.setItem("phoneNumber", phone);
}

function getToken() {
    return localStorage.getItem("token");
}

function getRestaurantOwnerId() {
    return localStorage.getItem("restaurantOwnerId");
}

function getRestaurantOwnerName() {
    return localStorage.getItem("restaurantOwnerName");
}

function getPhoneNumber() {
    return localStorage.getItem("phoneNumber");
}

function clearLoginInfo() {
    localStorage.removeItem("token");
    localStorage.removeItem("restaurantOwnerId");
    localStorage.removeItem("restaurantOwnerName");
    localStorage.removeItem("phoneNumber");
}

export default {
    name: 'loginStorage',
    storeToken,
    storeRestaurantOwnerId,
    storeRestaurantOwnerName,
    storePhoneNumber,
    getToken,
    getRestaurantOwnerId,
    getRestaurantOwnerName,
    getPhoneNumber,
    clearLoginInfo
} 